import { httpClient } from '../http/httpClient'
import { SupportRequest } from '@/app/entities/SupportRequest'

export async function getDetailByNumber(number: string) {
  const { data } = await httpClient.get<SupportRequest>(
    `/support-requests/${number}`,
  )

  return data
}
